<template>
  <div class="patent-pending">
    {{ $l.patentPending }}
  </div>
</template>

<script>
import MixinLocale from '@/components/MixinLocale'

export default {
  mixins: [
    MixinLocale
  ]
}
</script>
